import React from "react";

const ExperienceCard = ({ data }) => {
  return (
    <div className="experience-card mb-4">
      <div className="experience-visual">
        {data.logo ? (
          <img src={data.logo} alt={`${data.company} logo`} />
        ) : (
          <i className={data.icon || "fas fa-briefcase"} />
        )}
      </div>
      <div className="experience-body">
        <div className="d-flex justify-content-between align-items-baseline flex-wrap">
          <p className="experience-role mb-1">
            {data.role} · {data.company}
          </p>
          <p className="experience-meta mb-1">{data.date}</p>
        </div>
        {data.blurb && <p className="experience-blurb mb-0">{data.blurb}</p>}
      </div>
    </div>
  );
};

export default ExperienceCard;
